import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "category",
  "use": "category-usage",
  "viewBox": "0 0 36 35",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 35\" id=\"category\"><path fill=\"#BB1F42\" d=\"M.898 0h34.77v34.769H.897z\" /><path d=\"M12.027 7.649V28.51M16.2 7.649V28.51M20.371 7.649V28.51M24.543 7.649V28.51M28.715 11.821H7.854M28.715 15.993H7.854M28.715 20.166H7.854M28.715 24.338H7.854\" stroke=\"#fff\" stroke-width=\"1.043\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol